import type { ComponentProps } from 'react';

import { cn } from '@/shared/utils/cn';

export interface MainLayoutRootProps extends ComponentProps<'div'> {}

const MainLayoutRoot = (props: MainLayoutRootProps) => {
  const { children, className, ...rest } = props;

  return (
    <div
      {...rest}
      className={cn(
        'relative flex min-h-full w-full flex-col items-center lg:pl-(--navbar-width)',
        className,
      )}
    >
      {children}
    </div>
  );
};

export interface MainLayoutContentProps extends ComponentProps<'div'> {}

const MainLayoutContent = (props: MainLayoutContentProps) => {
  const { children, className, ...rest } = props;

  return (
    <div
      {...rest}
      className={cn('pb-navbar w-full max-w-160 flex-1 lg:pb-0', className)}
    >
      {children}
    </div>
  );
};

export const MainLayout = {
  Root: MainLayoutRoot,
  Content: MainLayoutContent,
};
